const MessageDeletedLine = ({ className = '', width = 16, height = 16, ...props }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M9.11523 16.5C4.97298 16.5 1.61523 13.1422 1.61523 9C1.61523 4.85775 4.97298 1.5 9.11523 1.5C13.2575 1.5 16.6152 4.85775 16.6152 9C16.6152 13.1422 13.2575 16.5 9.11523 16.5ZM9.11523 15C10.7065 15 12.2327 14.3679 13.3579 13.2426C14.4831 12.1174 15.1152 10.5913 15.1152 9C15.1152 7.4087 14.4831 5.88258 13.3579 4.75736C12.2327 3.63214 10.7065 3 9.11523 3C7.52394 3 5.99781 3.63214 4.87259 4.75736C3.74738 5.88258 3.11523 7.4087 3.11523 9C3.11523 10.5913 3.74738 12.1174 4.87259 13.2426C5.99781 14.3679 7.52394 15 9.11523 15V15ZM12.7835 6.39225L6.50748 12.6683C6.09752 12.3761 5.7391 12.0177 5.44698 11.6078L11.723 5.33175C12.133 5.62387 12.4914 5.98228 12.7835 6.39225V6.39225Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default MessageDeletedLine;
